import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  SkeletonLine,
  useBreakpoint,
} from '~/techstyle-shared/react-components';

import { getProductImageSizeHeight } from '../../utils/images';

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 8px;
`;

const ProductCardSkeleton = ({ width, height }) => {
  const { isMobile } = useBreakpoint();
  const lineWidth = width ?? '100%';
  const halfLineWidth = typeof lineWidth === 'number' ? lineWidth * 0.5 : '50%';
  const fallbackImageHeight = getProductImageSizeHeight(isMobile);
  const skeletonImageHeight = height ? height * 0.7 : fallbackImageHeight;

  return (
    <SkeletonWrapper>
      <SkeletonLine width={lineWidth} height={skeletonImageHeight} />
      <SkeletonLine width={lineWidth} height="16px" />
      <SkeletonLine width={lineWidth} height="16px" />
      <SkeletonLine width={halfLineWidth} height="16px" />
    </SkeletonWrapper>
  );
};

ProductCardSkeleton.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

export default ProductCardSkeleton;
